import { useCallback, useEffect, useRef, useState } from 'react';

const useContainerWithScrollArrow = ({
  recalculateWhenThisChange,
}: {
  recalculateWhenThisChange: any;
}) => {
  const containerRef = useRef<HTMLDivElement>();
  const [showScrollButton, setShowScrollButton] = useState(false);

  const showScrollButtonIfAppropriate = useCallback(() => {
    const containerElement = containerRef.current;
    if (!containerElement) return;

    const isAtBottom =
      containerElement.scrollHeight - containerElement.scrollTop <=
      containerElement.clientHeight + 100; // 100px threshold (don't show the arrow if there's less than 100px to scroll)
    setShowScrollButton(!isAtBottom);
  }, [containerRef]);

  const scrollToBottom = useCallback(() => {
    const containerElement = containerRef.current;
    containerElement?.scrollTo({ top: containerElement.scrollHeight, behavior: 'smooth' });
  }, [containerRef]);

  useEffect(() => {
    showScrollButtonIfAppropriate();
  }, [recalculateWhenThisChange, showScrollButtonIfAppropriate]);

  useEffect(() => {
    const containerElement = containerRef.current;
    if (containerElement) {
      containerElement.addEventListener('scroll', showScrollButtonIfAppropriate);
      showScrollButtonIfAppropriate();
      return () => containerElement.removeEventListener('scroll', showScrollButtonIfAppropriate);
    }
  }, [showScrollButtonIfAppropriate, containerRef]);

  return { showScrollButton, scrollToBottom, containerRef, showScrollButtonIfAppropriate };
};

export default useContainerWithScrollArrow;
